<template>
  <div ref="dropdown" class="dropdown-wrap">
    <label class="label input__label">{{this.label}}</label>
    <button 
      :class="setButtonClass"
      @click="setActive"
      :active="false"
    ><span class="button__text">{{ setLabel() }}</span><Icon icon="chevron-down"></Icon></button>
    <div class="dropdown__list-wrap">
      <ul class="dropdown__list">
        <li class="dropwdown__item" v-for="(item, index) in getPrototype">
          <input class="dropdown__input" 
            :id="id + '_' + index" 
            :name="id + '[]'" 
            :value="index"
            :checked="setValue === index"
            type="radio" 
            @change="saveValue"
          >
          <label class="dropdown__input-label" 
            :for="id + '_' + index"
            @click="isCurrent"
            v-html="getChoiceValue(item)"
          >
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import Icon  from './Icon.vue'

export default {

  /**
   * COMPONENTS
   * ----------
   * 
   * These are the components that can be used by this 
   * component
   */
  
  components: {
    Icon
  },  

  methods: {

    setLabel() {

      var val = '--';

      if ( this.field !== undefined &&
           this.context !== 'snapshot' ) {

        val = this.$store.getters.getDropdownData({ field: this.field, proto: this.proto });

        if ( this.context === 'modal' ) {

          // val = 'test this';
          
        }

      }

      else if ( this.context === 'snapshot' ) {

          var line = '',
              date = this.$parent.$data.snapshotDate,
              segment = this.field.split('.');

          if ( ! date ) { return val; }

          segment = segment[1];

          var proto = this.$store.getters.getPrototype('dropdown', this.proto);
          
          line = date[segment];
          for (var key in proto) {

            if ( Number(line) === Number(key) ) {

              val = proto[key];

            }

          }

      }

      else if ( this.context === 'repeater' ) {

        var proto = this.$store.getters.getPrototype('dropdown', this.proto);

        for ( var x in proto ) {

          if ( this.value === x ) {

            val = proto[x];

          }

        } 

      }

      return this.getChoiceValue(val);

    },

    getChoiceValue(item) {

      var val = this._translate('dropdown.' + this.proto + '.' + item);
      return (val === '[undefined string]') ? item : val;

    },      

    saveValue(e) {

      var val = e.target.value,
          d   = true;

      // Check for context
      if (this.context) {

        if ( this.context === 'repeater' ) {

          var vars = this.$parent.$parent.$data.subpanel;
          
          this.$store.dispatch('saveCell', {
            field: vars.field,
            row:   this.row,
            index: this.index,
            key:   this.k,
            type:  'dropdown',
            value: val,
          });

          d = false;

        }

        else if ( this.context === 'modal' ) {

          var modal = this.$store.getters.modalVars;

          if ( modal.component === 'printForm') {

            this.$store.dispatch('savePrintOption', {
              field: this.field,
              value: val,
            });

          }

          d = false;

        }

        else if (this.context === 'snapshot' ) {

          var segment = this.field.split('.');
              segment = segment[1];

          this.$emit('updateDate', {
            field : segment,
            value : val
          });

          d = false;

        }

      }

      if (d) { 

        this.$store.dispatch('saveField', {
          field: this.field,
          value: val,
        });

      }

    },

    setActive(e) {

      e.preventDefault();
      e.stopPropagation();

      this.$data.active = ! this.$data.active;

    },

    isCurrent(e) {

      // Check the current item.
      // This is HIGHLY dependent on the template structure
      if ( e.path[1].children[0].checked ) {

        this.$data.active = false;

      }

    }

  },
  
  computed: {

    setValue() {

      var val = '';

      if ( this.field !== undefined &&
           this.context !== 'repeater' &&
           this.context !== 'modal' &&
           this.context !== 'snapshot') {

        val = this.$store.getters.getFieldData({ field: this.field });

      }

      else if ( this.context === 'repeater' ) {

        val = '';

      } 

      else if ( this.context === 'modal' ) {

        var modal = this.$store.getters.modalVars,
            val = '';

        if ( modal.component === 'printForm') {

          var print = this.$store.getters.getPrintOptions;

          val = print[this.field];

        }

      }

      else if ( this.context === 'snapshot' ) {


      }     

      this.$data.active = false;

      return val;

    },

    getPrototype() {

      var proto = this.$store.getters.getPrototype('dropdown', this.proto);

      return proto;

    },

    setButtonClass() {

      var c = "input dropdown__button";

      if (this.$data.active) {

        c += ' js-active';

      }

      return c;

    }

  },

  props : [

    // Default props
    'field',
    'label',
    'proto',
    'id',
    'context',
    'value',
    // 'order',

    // Repeater-specific props
    // These props are used in repeaters to help map cell inputs
    // to data in the state.
    'row',
    'index', 
    'k',      // represents 'key' which is a reserved prop name 

  ],  

  data() {

    return {

      active: false,
      clickoff: true,

    }

  },

  mounted: function() {


  }

}

</script>

<style lang="scss">

  .dropdown-wrap {

    // border: 1px solid red;
    position: relative;
    margin: 0 0 .75rem;

  }

  .dropdown__list-wrap {
    
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% + 1rem);
    z-index: 2;    

    opacity: 0;
    visibility: hidden;

    transition-delay: 0;

  }

  .dropdown__list {

    padding: 0;
    list-style-type: none;

    font-size: .75rem;

    background: #33343b;

    padding: 0;
    border-radius: 2px;

    overflow: auto;
    max-height: 10rem;

    color: #fff;

    &::before {

      content: '';
      display: block;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 6px 8px 6px;
      border-color: transparent transparent #33343b transparent;

      position: absolute;
      top: -8px;
      left: 1rem;

    }

  }

  .dropdown__input {

    display: none;

    &:checked + .dropdown__input-label {

      background-color: rgba(0, 0, 5, 0.1);

      &:hover {

        background-color: rgba(0, 0, 5, 0.45);

      }

    }

  }

  .dropdown__input-label {

    padding: .5rem .75rem;
    display: block;
    cursor: pointer;

    &:hover {

      background-color: rgba(0, 0, 5, 0.4);

    }

  }

  .dropdown__button {

    position: relative;

    &.js-active {

      + .dropdown__list-wrap {

        opacity: 1;
        visibility: visible;

      }

     .icon {

        transform: translate3d(0, 0, 0) rotate(-180deg);

      }      

    }

    .button__text { 

      display: block;
      margin-right: 1.75em;
      white-space: nowrap;
      overflow: hidden;  
      text-overflow: ellipsis; 

    }

    .icon {

      position: absolute;
      top: .65rem;
      right: 1rem;

      width: .75rem;
      height: 1.15rem;

      transform: translate3d(0, 0, 0) rotate(0);
      transform-origin: center;

      transition: transform .2s ease;


    }

    .icon__svg {

      stroke: #444;

    }

  }

</style>



// WEBPACK FOOTER //
// Dropdown.vue?6c2c06f2